import React from 'react';
import PropTypes from 'prop-types';

import downloadIcon from 'images/icons/invite/download.svg';

export default function RowActions({ row }) {
  return (
    <a href={row.attributes.url} target="_blank" rel="noreferrer">
      <img src={downloadIcon} alt="download" />
    </a>
  );
}

RowActions.propTypes = {
  row: PropTypes.object.isRequired,
};
